import React from "react";

import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import './Card.scss';

const Card = ({ project, openModal, setModalData }) => {

    const openCode = () => {
        window.open(project.code);
    }

    const openProject = () => {
        window.open(project.demo);
    }

    return (

        <ImageListItem>
            <img
                src={project.image}
                srcSet={project.image}
                alt={project.title}
                loading="lazy"
            />
            
            <ImageListItemBar
                title={project.title}
                // subtitle={project.brief}
                actionIcon={
                    <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${project.title}`}
                        onClick={()=> {
                            setModalData(project);
                            openModal();
                        }}
                    >
                        <InfoIcon />
                    </IconButton>
                }
            />
        </ImageListItem>
    );
}

export default Card;